import React from 'react';
import CustomToolTip from '../../CustomToolTip';
import '../styles/telemetry-jump-to-live-button.css';

export interface TelemetryJumpToLiveButtonProps {
  isPaused: boolean;
  jumpToLive: () => void;
  isZoomed?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const TelemetryJumpToLiveButton: React.FC<TelemetryJumpToLiveButtonProps> = ({
  isPaused,
  jumpToLive,
  isZoomed = false,
  className = '',
  style,
}) => {
  const isActive = isZoomed || isPaused;

  const tooltipTitle = isZoomed
    ? 'Reset Zoom'
    : isPaused
      ? 'Jump to Live'
      : 'Live';

  return (
    <CustomToolTip title={tooltipTitle}>
      <button
        id="telemetry-jump-to-live-btn"
        className={`td-live-btn ${isActive ? 'td-toolbar-btn--zoomed' : 'td-live-btn--live'} ${className}`}
        disabled={!isActive}
        onClick={jumpToLive}
        aria-label={tooltipTitle}
        style={style}
      >
        {isZoomed ? (
          /* Reset Zoom Icon (↺) */
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="1 4 1 10 7 10" />
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
          </svg>
        ) : isPaused ? (
          /* Jump to Live Forward Arrow Icon */
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 19v-4a4 4 0 0 1 4-4h7" />
            <polyline points="12 6 16 11 12 16" />
            <polyline points="17 6 21 11 17 16" />
          </svg>
        ) : (
          /* Live Dot */
          <span className="td-live-dot" />
        )}
      </button>
    </CustomToolTip>
  );
};

export default TelemetryJumpToLiveButton;


